module.exports = __webpack_public_path__ + "img/perki.7d69e0ec.png";